import { UPDATE_FRONT_STYLE_EVH } from "./frontStyleEvhReducer"

export const updateFrontStyleEvh = (status) => ({
    type: UPDATE_FRONT_STYLE_EVH,
    payload: status
})
